import { DTOToTemplate, templateToDTO } from '@/typescript/transformers/template';
import { clearImageStorage, initImages, saveImages } from '@/utils/idbImageStorage';
import type { ITemplate } from '@/typescript/interfaces/ITemplate';
import type { ITemplateDTO } from '@/typescript/interfaces/ITemplateDTO';

async function saveToLocalStorage(template: ITemplate, currentProjectId: string) {
    await saveImages(template, currentProjectId);
    window.localStorage.setItem(currentProjectId, JSON.stringify(templateToDTO(template)));
    return currentProjectId;
}

async function loadFromLocalStorage(projectId: string): Promise<ITemplate | undefined> {
    const serializedTemplate = window.localStorage.getItem(projectId);
    if (!serializedTemplate) {
        return undefined;
    }
    const templateDTO = JSON.parse(serializedTemplate) as ITemplateDTO;
    const template = await initImages(DTOToTemplate(templateDTO), projectId);

    return template;
}

async function clearLocalStorage() {
    await clearImageStorage();
    localStorage.clear();
}

export { clearLocalStorage, loadFromLocalStorage, saveToLocalStorage };
